module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1r3r6r-618114ff5027fda6abff2b78cccbda7b.svg";